import { components } from "react-select";

export const CustomOption = (props: any) => {
  const { data } = props;

  return (
    <components.Option {...props}>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <img
          src={data.image}
          alt={data.label}
          style={{
            width: "40px",
            height: "30px",
            objectFit: "cover",
            borderRadius: "6px",
          }}
        />
        <span>{data.label}</span>
      </div>
    </components.Option>
  );
};
